<template>
  <div class="fullarea">
    <div v-show="!zoomed" class="image-area" :class="{static: noflow}" v-on:mousedown="switchToZoom()" ref="scaled">
      <img :src="imgsrc" :style="{opacity: mop}" class="transing" />
    </div>
    <div class="dragarea" v-show="zoomed">
      <div v-on:mousedown="startDrag" v-on:mousemove="handleDrag" 
        v-if="zoomed" :style="{width: width + 'px', height: height + 'px', cursor: cursorName }" class="zoomed-view">
        <img :src="imgsrc" ref="bigImage" :style="{top: imageloc.top + 'px', left: imageloc.left + 'px', opacity: opie}"/>
      </div>
    </div>
    <div class="zoom-toggle" :class="{out: zoomed}" v-on:click.stop.prevent="toggleZoom"></div>
  </div>
</template>

<script>
export default {
  props: {
    src: String,
    zoom: Boolean,
    noflow: Boolean
  },
  data () {
    return {
      hideImage: false,
      zoomed: false,
      imgsrc: '',
      width: 0,
      height: 0,
      mousepos: { x: 0, y: 0 },
      isMouseDown: false,
      imagesize: { width: 0, height: 0 },
      imageloc: { top: 0, left: 0 },
      cursorName: 'grab',
      opie: 0,
      mop: 0
    }
  },
  created: function () {
    if(this.src) {
      this.loadImage()
    }
  },
  mounted: function () {
    window.addEventListener('mouseup', () => {
      this.endDrag()
    })
  },
  methods: {
    loadImage: async function () {
      this.mop = 0
      this.imgsrc = this.src
      await this.$k.loadImage(this.src)
      this.$nextTick(() => {
        this.mop = 1
      })
    },
    toggleZoom: function () {
      if(!this.zoomed) {
        this.switchToZoom()
      }
      else {
        this.zoomed = false
        this.$emit('zoom', false)
      }
    },
    switchToZoom: async function () {
      this.width = this.$refs.scaled.offsetWidth
      this.height = this.$refs.scaled.offsetHeight
      this.zoomed = true
      await this.$k.waitfor(200)
      this.centerImage()
      this.$emit('zoom', true)
    },
    startDrag: function () {
      this.mousepos.x = event.clientX - this.imageloc.left;
      this.mousepos.y = event.clientY - this.imageloc.top;
      this.isMouseDown = true
      this.cursorName = 'grabbing'
    },
    centerImage: function () {
      let cx = (this.width / 2) - (this.$refs.bigImage.offsetWidth/2)
      let cy = (this.height / 2) - (this.$refs.bigImage.offsetHeight/2)
      this.imageloc.left = cx
      this.imageloc.top = cy
      this.opie = 1
    },
    endDrag: function () {
      this.isMouseDown = false
      this.cursorName = 'grab'
    },
    handleDrag: function (event) {
      if(this.isMouseDown){
        let newleft = event.clientX - this.mousepos.x
        let newtop = event.clientY - this.mousepos.y
        // constrain
        
        if(newleft > 0) newleft = 0
        if(newtop > 0) newtop = 0
        const w = this.$refs.bigImage.offsetWidth
        if(w + newleft < this.width) {
          newleft = this.width - w
        }
        const h = this.$refs.bigImage.offsetHeight
        if(h + newtop < this.height) {
          newtop = this.height - h
        }
        this.imageloc.left = newleft
        this.imageloc.top = newtop
        
      }
    }
  },
  watch: {
    src: function () {
      this.loadImage()
    },
    zoom: function () {
      if(this.zoom === false) {
        
        this.zoomed = false
      }
    }
  }
  
}
</script>

<style scoped>
.image-area{
  cursor:zoom-in;
  display:inline-block;
}

.image-area img{
  max-width:60vw;
  max-height:calc(98vh - 80px);
  display:block;
}

.image-area.static img{
  max-width:60vw;
  max-height:40vh;
  display:block;
}


.transing{
  transition:all 0.6s ease;
}

.zoomed-view{
  overflow: hidden;
  user-select: none;
  position:relative;
  cursor:grab;
}

.zoomed-view img{
  user-select: none;
  pointer-events: none;
  position:absolute;
  display:block;
  top:0;
  left:0;
  transition:opacity 0.3 ease;
}

.fullarea{
  position:relative;
  display:inline-block;
}

.zoom-toggle{
  width:32px;
  height:32px;
  background-repeat: no-repeat;
  background-size: contain;
  cursor:pointer;
  background-image:url('../../assets/img/zoomin-ol.svg');
  position:absolute;
  opacity:0.6;
  bottom:20px;
  right:20px;
  transition:all 0.15s ease;
  z-index:20;
}

.zoom-toggle:hover{
  opacity:1;
  transform: scale(1.1);
}

.zoom-toggle.out{
  background-image:url('../../assets/img/zoomout-ol.svg');
}

@media screen and (max-width:960px){
  .image-area img{
    max-width:calc(95vw - 20px);
    max-height:calc(98vh - 40px);
    display:block;
  }
}
</style>
